/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { Grid, Typography } from '@material-ui/core';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import StatusChip from '../common/StatusChip';
import { getSubmissionErrorMessages, getSubmissionTitle } from '../../shared/submission/submissionPropertyAccessor';
import { useUiSchema } from '../../shared/rjsf/useUiSchema';
import { getSubmissionStatusId } from '../../models/SubmissionStatus';

export default function PreviewHeader({ className, submission, headerTitle }) {
  const { t } = useTranslation();
  const { uiSchema } = useUiSchema();

  const errorText = getSubmissionErrorMessages(submission);
  const submissionTitle = getSubmissionTitle(submission, uiSchema);

  const component = (
    <div className={className}>
      <Typography variant="h1">{headerTitle}</Typography>
      <Grid container justifyContent="space-between">
        <Grid
          container item justifyContent="flex-start" alignItems="center" spacing={2}
          xs={6}
        >
          <Grid item>
            <Typography variant="h2">{submissionTitle}</Typography>
          </Grid>

          {submission?.filter?.statusOrder && (
            <Grid item>
              <StatusChip
                status={getSubmissionStatusId(submission.filter.statusOrder)}
                addHiddenInfo={true}
                errorText={errorText}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </div>
  );

  return useMemo(() => component, [
    submission,
submission?.status,
headerTitle,
t,
submissionTitle,
  ]);
}
